import { render } from "./Folders.vue?vue&type=template&id=26e2f1be&scoped=true"
import script from "./Folders.vue?vue&type=script&lang=js"
export * from "./Folders.vue?vue&type=script&lang=js"

import "./Folders.vue?vue&type=style&index=0&id=26e2f1be&lang=less&scoped=true"

import exportComponent from "/var/www/eventgallery/build/tmpBuildDir/components/com_eventgallery/media/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26e2f1be"],['__file',"backend/vue/components/Folders.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "26e2f1be"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('26e2f1be', __exports__)) {
    api.reload('26e2f1be', __exports__)
  }
  
  module.hot.accept("./Folders.vue?vue&type=template&id=26e2f1be&scoped=true", () => {
    api.rerender('26e2f1be', render)
  })

}


export default __exports__